import type { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

export const CREDIT_CARD_OFFER_FIELDS_FRAGMENT: DocumentNode = gql`
  fragment CreditCardOfferFields on CreditCardsOfferV2 {
    analyticsProps {
      hasLegacyImpression
      institutionId
      legacyAdditionalEventData
      legacyIssuer
      legacySlug
      legacyVertical
      offerId
      productId
    }
    annualFee
    annualFeeDetails
    applyLink
    approvalLikelihood
    aprDisplayList
    aprIntroMessageList
    aprMax
    aprMin
    balanceTransferFee
    balanceTransferIntroApr
    balanceTransferIntroTime
    bestOfAwards {
      category
      year
    }
    billingCycleUnits
    cardUser
    cobrandAirline
    cobrandHotel
    consBullets
    cta {
      link
      showIcon
      subtext
      text
      type
    }
    displayName
    driverAnnualFee {
      label
      value
    }
    driverBalanceTransferFeeDescription {
      description
      label
      value
      valueTooltip
    }
    driverBonus {
      description
      label
      value
      valueTooltip
    }
    driverForeignTransactionFee {
      description
      label
      value
      valueTooltip
    }
    driverIntroApr {
      label
      value
    }
    driverIntroOffer {
      description
      label
      value
      valueTooltip
    }
    driverMinimumDeposit {
      description
      label
      value
    }
    driverRegularApr {
      label
      value
      valueTooltip
    }
    driverRewardRate {
      description
      label
      value
      valueTooltip
    }
    eligibleForNerdWalletPlusBonus
    entityType
    foreignTransactionFee
    id
    image {
      height
      resizableImagePath
      source
      sourceLarge
      sourceMedium
      width
    }
    institution {
      id
      name
    }
    introBalanceTransfers
    introPurchases
    legacyId
    limitedCreditHistory
    marketingBullets
    maxFico
    minFico
    minimumDeposit
    monetizable
    name
    ongoingApr
    perks
    phoneNumber
    product {
      id
      name
    }
    productType
    prosBullets
    purchaseIntroApr
    purchaseIntroTime
    reviewLink
    rewardRate
    rewardRateDetails
    rewardRateNotes
    rewardType
    rewards {
      category
      isTiered
      period
      rate
      recommendationCategory
    }
    rewardsRates {
      description
      rate
    }
    showNameInComparisonTable
    signUpBonus
    signUpBonusDetails
    signUpBonusDetailsAnnotation
    signUpBonusType
    starRating
    starRatingTooltip
    status
    termsAndFeesLink
    versionId
  }
`;

export const CREDIT_CARD_OFFERS_QUERY: DocumentNode = gql`
  query GetCreditCardOffers($namedQuery: String!, $limit: Int!, $offset: Int!) {
    marketplaceSearch(
      productType: "CREDIT_CARDS"
      entityType: "OFFERS"
      namedQuery: $namedQuery
      pagination: { limit: $limit, offset: $offset }
      query: [
        { field: "offer.status", type: "eq", value: "ACTIVE" }
        { field: "offer.product.status", type: "eq", value: "ACTIVE" }
        { field: "offer.product.institution.status", type: "eq", value: "ACTIVE" }
        { field: "offer.details.compare_categories", type: "contains_none_of", value: ["shadow-card"] }
      ]
    ) {
      entities {
        ... on CreditCardsOfferV2 {
          ...CreditCardOfferFields
        }
      }
    }
  }
  ${CREDIT_CARD_OFFER_FIELDS_FRAGMENT}
`;
